import { useEffect, useState } from 'react';
import { subscribeSSE } from '../api/client';
import type { StatusEvent } from '../components/status/StatusDisplay';

export function useStatusStream(conversationId: string | undefined, active: boolean) {
  const [events, setEvents] = useState<StatusEvent[]>([]);

  useEffect(() => {
    if (!conversationId || !active) {
      setEvents([]);
      return;
    }
    const cleanup = subscribeSSE(
      `/conversations/${conversationId}/status`,
      {
        onMessage: (e) => {
          try {
            const data = JSON.parse((e as MessageEvent).data);
            if (typeof data?.text === 'string') {
              setEvents((prev) => [
                ...prev,
                { text: data.text, tool: data.tool, count: data.count, receivedAt: Date.now() },
              ]);
            }
          } catch {
            /* ignore non-JSON */
          }
        },
        onError: () => {
          // SSE auto-reconnects; ignore
        },
      },
      ['status'],
    );
    return cleanup;
  }, [conversationId, active]);

  return events;
}
